<template>
  <div>
    <b-row>
        <b-col cols="12">
          <b-table
              striped
              hover
              responsive
              :items="items"
              :fields="fields"
          >
            <template #cell(Driver)="data">
              <b-row v-for="d in data.Driver">
                <b-badge
                    class="mb-1"
                    v-bind:style="{color: d.Color2, background: d.Color1, width: '100%'}"
                >{{ d.title }}
                </b-badge>
              </b-row>
            </template>
            <template #cell(ExpectedTime)="data">

              <b-badge
                  v-show="data.item.ExpectedTime != null"
                  class="mb-1"
                  :variant="getVariant(data.item.ExpectedTime)"
              >
                {{ data.item.ExpectedTime }}
              </b-badge>
            </template>
          </b-table>
        </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BButton, BImg, BRow, BCol, BTable, BAvatar, BAlert, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BFormDatepicker, BInputGroupAppend, BDropdown, BDropdownDivider, BDropdownForm, BDropdownGroup, BDropdownItem } from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'

export default {
  components: {
    BTable,
    BAvatar,
    BAlert,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BFormDatepicker,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownDivider,
    BDropdownForm,
    BDropdownGroup,
    BDropdownItem,
  },
  data() {
    return {
      fields: [
        {
          key: 'Time',
          label: 'Zeit',
        },
        {
          key: 'ExpectedTime',
          label: 'Ankunft',
        },
        {
          key: 'Iata',
          label: 'Flugnummer',
        },
        {
          key: 'Passengers',
          label: 'Personen',
        },
        {
          key: 'Customer',
          label: 'Kunde',
        },
        {
          key: 'Driver',
          label: 'Fahrer',
        },
        {
          key: 'driverTime',
          label: 'Zeit Fahrer',
        },
      ],
      items: [],
      drivers: []

    }
  },
  mounted() {

    this.LoadVehicleList()
    this.LoadDriverList()
  },
  computed: {
  },
  methods: {
    LoadVehicleList() {
      this.vehicleList = []
      this.$http.get(`/vehicle/list`)
          .then(resp => {
            resp.data.forEach(p => {
              this.vehicleList.push({
                value: p.VId,
                text: p.NumberPlate
              })
            })

          })
          .catch(err => {
            console.error(err)
          })
    },
    LoadDriverList() {
      this.drivers = []
      this.$http.get(`/driver/list?propertys=DriverShortName,DId,Color1,Color2,NumberPlate&option=1`)
          .then(resp => {
            let list = []

            this.drivers = Object.freeze(list)
            this.LoadList()

          })
          .catch(err => {
            console.error(err)
          })
    },
    getVariant(expectedTime) {
      const currentTime = new Date();
      const expectedDateTime = new Date(expectedTime); // Ändern Sie diese Zeile entsprechend dem Zeitformat von ExpectedTime

      if (currentTime >= expectedDateTime) {
        return 'success';
      }
      return 'warning';
    },
    LoadList() {
      this.items = []

      let url = `/disposition/get/${this.$route.params.day}?from=1&count=500`
      this.$http.get(url, { timeout: 10 * 60 * 1000 })
          .then(resp => {

            resp.data.forEach(i => {
              i.Driver = []

              for (const [Driver, Vehicle] of Object.entries(i.Drivers)) {

                console.log(Driver)
                this.drivers.forEach(dl => {
                  console.log(dl)
                  if (dl.driverId == Driver) {
                    const veh = ''

                    this.vehicleList.forEach(veh => {
                      if (veh.value == Vehicle) {
                        i.Driver.push({
                          driverId: dl.driverId,
                          title: dl.title + (!dl.title.includes('(' + veh.text + ')') ? ' (' + veh.text + ')' : ''),
                          Color1: dl.Color1,
                          Color2: dl.Color2,

                        })
                        this.headerDrivers.forEach(i2 => {
                          if (Driver == i2.Driver.DId) {
                            i2.TripCount++
                          }
                        })
                      }
                    })
                  }
                })
              }

              console.log(i)

              this.items.push({
                Time: i.PickupTime,
                ExpectedTime: i.Flight ? i.Flight.ExpectedTime : null,
                Iata: i.Flight.Iata,
                Passengers: i.Passenger.Passengers + " + " + i.Passenger.PassengersChildren,
                Customer:  i.PickUpAddress.Name,
                Driver: i.Driver,

              })
            })

          })
          .catch(err => {
            console.error(err)
          })

    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
